export const GERMAN_COUNTRY_NAME = 'Deutschland';
export const GERMAN_COUNTRY_CODE = 'DE';
